<div class="col">
    <app-shop />
</div>
